import DownloadButton from "@buttons/DownloadButton";
import SelectOperator from "@shared/SelectOperator";
import React from "react";
import { connect } from "react-redux";
import {
  Accordion,
  Button,
  Form,
  Icon,
  Input,
  Select,
} from "semantic-ui-react";

class EGMFilters extends React.Component {
  state = {
    statusOpen: false,
  };

  handleSelection = (event, { name, value }) =>
    this.props.onChange(name, value);

  handleStatusClick = (value) => {
    let selectedStatus = [...this.props.searchParams.selectedStatus];

    if (selectedStatus.includes(value)) {
      selectedStatus = selectedStatus.filter((x) => x !== value);
    } else {
      selectedStatus.push(value);
    }

    this.props.onChange("selectedStatus", selectedStatus);
  };

  getSelect = (selectedKey, arrayKey) => {
    const disabled = !this.props.searchParams.selectedOperator;
    return (
      <Select
        search
        disabled={disabled}
        options={this.props.filters[arrayKey]}
        value={this.props.searchParams[selectedKey]}
        name={selectedKey}
        onChange={this.handleSelection}
        fluid
      />
    );
  };

  render() {
    const disabled = !this.props.searchParams.selectedOperator || this.props.loading || false;

    const billValidatorDisplay  = this.props.logIn.billValidatorDisplay;

    return (
      <Accordion fluid styled exclusive={false}>
        <Accordion.Content active>
          <Form>
            <Form.Field>
              <label>Operator:</label>
              <SelectOperator
                fluid
                operators={this.props.operators}
                value={this.props.searchParams.selectedOperator}
                name="selectedOperator"
                onChange={this.props.onOperatorChange}
              />
            </Form.Field>

            <Form.Field>
              <label>Depot:</label>
              {this.getSelect("selectedDepot", "depots")}
            </Form.Field>

            <Form.Field>
              <label>Group By:</label>
              {this.getSelect("selectedGrouping", "groupings")}
            </Form.Field>

            <Form.Field>
              <label>Supplier:</label>
              {this.getSelect("selectedSupplier", "suppliers")}
            </Form.Field>

            <Form.Field>
              <label>Ownership Profile:</label>
              {this.getSelect("selectedOwnershipProfile", "profiles")}
            </Form.Field>

            <Form.Field>
              <label>Search:</label>
              <Input
                fluid
                name="searchText"
                disabled={disabled}
                onChange={this.handleSelection}
              />
            </Form.Field>

            <Button
              icon="refresh"
              disabled={disabled}
              loading={this.props.loading || false}
              size="small"
              onClick={this.props.onRefresh}
              positive
              content="Refresh"
              fluid
            />
            <DownloadButton
              disabled={disabled}
              onClick={this.props.onDownloadClick}
              caption="Export"
              fluid
            />
          </Form>
        </Accordion.Content>
        <Accordion.Title
          active={this.state.filtersOpen}
          index={0}
          onClick={() =>
            this.setState({ filtersOpen: !this.state.filtersOpen })
          }
        >
          <Icon name="dropdown" />
          Additional Filters
        </Accordion.Title>
        <Accordion.Content active={this.state.filtersOpen}>
          <Form>
            <Form.Field>
              <label>Category:</label>
              {this.getSelect("selectedCategory", "categories")}
            </Form.Field>

            <Form.Field>
              <label>Manufacturer:</label>
              {this.getSelect("selectedManufacturer", "manufacturers")}
            </Form.Field>

            <Form.Field>
              <label>Game Title/Pack:</label>
              {this.getSelect("selectedGameTitle", "gameTitles")}
            </Form.Field>

            <Form.Field>
              <label>Cabinet Type:</label>
              {this.getSelect("selectedCabinetType", "cabinetTypes")}
            </Form.Field>

            <Form.Field>
              <label>{billValidatorDisplay ? "Bill Validator" : "Note Acceptor"}:</label>
              {this.getSelect(
                "selectedNoteAcceptorModel",
                "noteAcceptorModels",
              )}
            </Form.Field>

            <Form.Field>
              <label>Asset - Variant:</label>
              {this.getSelect("selectedVariant", "variants")}
            </Form.Field>
          </Form>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    operators: state.operators.filter((x) => x.value !== -1),
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, {})(EGMFilters);
